import script from "./MSR_SO_002.vue?vue&type=script&setup=true&lang=js"
export * from "./MSR_SO_002.vue?vue&type=script&setup=true&lang=js"

import "./MSR_SO_002.vue?vue&type=style&index=0&id=1b31b7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b31b7ce"]])

export default __exports__